module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/research-openings.json
// module id = 456
// module chunks = 54008286479987